module.exports = __webpack_public_path__ + "img/rvideo.5533da40.svg";